<template>
    <!-- 保單卡片 -->
    <Card
        :title="data.fullPolicyNo"
        :disabled="disabled"
        :cursor-pointer="!disabled"
        :tagText="data.memo"
    >
        <template #foldContent>
            <div class="row">
                <div class="label">
                    {{ columns[1] }}
                </div>
                <div class="value">
                    {{ data.currencyText }}
                </div>
            </div>
            <div class="row">
                <div class="label">
                    {{ columns[2] }}
                </div>
                <div class="value">
                    {{ data.name }}
                </div>
            </div>
            <div class="row">
                <div class="label">
                    {{ columns[3] }}
                </div>
                <div class="value">
                    <slot />
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import routeName from '@/router/constant.js';
import { useRoute } from 'vue-router';
import Card from '@/components/card/CardPolicyBase.vue';
import { formatToTwDateInterval } from '@/utils/is/dateUtils';

export default {
    components: {
        Card
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            required: true
        }
    },
    setup() {
        const route = useRoute();
        return {
            route,
            routeName,
            formatToTwDateInterval,
        };
    },
};
</script>

<style lang="scss" scoped>
.row {
    @apply pt-1 px-2.5 flex items-center justify-between min-h-[2.25rem];
}
.label {
    @apply font-normal flex-shrink-0 text-sm text-gray-400;
}
.value {
    @apply text-right text-gray-700 text-lg break-all text-lg;
}
.policy-card {
    &:not(.disabled) {
        .label {
            @apply text-gray-400;
        }
        .value {
            @apply text-gray-700;
        }
    }
    &.disabled {
        .label,
        .value {
            @apply text-gray-200;
        }
    }
}
</style>
